export default __webpack_public_path__ + "static/media/p-astistva.bb0bda92.jpg";